import { translations } from '../i18n/translations';

// Locks a translated label to its widest known rendering so switching language
// never reflows the layout around it - only the text itself changes, in place.
// One or more hidden "ghost" copies are stacked under the live text via a shared
// CSS grid cell (see .i18n-lock / .i18n-lock-block in App.css); the grid cell
// auto-sizes to the widest/tallest item placed in it, so the box never
// shrinks/grows below that size regardless of which language is currently showing.
//
// `en` can be passed directly (for composite/dynamic labels, e.g. "PRESS TO MINT 100")
// or omitted when `k` + `t` are given (looks it up as translations.en[k]).
// `ghosts` accepts extra literal strings to also floor the size by (e.g. a toggle
// button whose label isn't "the translation of one key" but one of N fixed strings).
// `block` renders a full-width grid (for wrapping paragraphs) instead of inline-grid.
//
// Ghosts render as `content: attr(data-ghost)` on an EMPTY span (see App.css) rather
// than as a real text child. Generated content is still laid out/measured, so sizing
// is unaffected, but it isn't part of the DOM text tree - a raw text query (Playwright's
// getByText, which unlike getByRole does NOT respect aria-hidden) can never match it.
// A real hidden text node holding the same string as the visible label - true whenever
// the ghost's language (English) happens to be the one currently showing - resolved
// exact-text lookups and `.first()` clicks in e2e tests to the invisible ghost.
export function I18nLock({ t, k, en, ghosts, className, style, children, block }) {
  const ghost = en ?? (t && k ? translations.en[k] : undefined);
  const label = children ?? (t && k ? t[k] : undefined);
  const extra = ghosts || [];
  return (
    <span className={`${block ? 'i18n-lock-block' : 'i18n-lock'}${className ? ` ${className}` : ''}`} style={style}>
      {ghost != null && <span className="ghost" aria-hidden="true" data-ghost={ghost} />}
      {extra.map((g, i) => <span className="ghost" aria-hidden="true" data-ghost={g} key={i} />)}
      <span>{label}</span>
    </span>
  );
}

export default I18nLock;
